import { getPortalHomeHero } from '@/api/portal'
import { normalizeHeroData } from '@/components/home/utils/heroNormalize'

let heroFetchSeq = 0
let inflightHeroFetch = null

const emptyHero = () => ({
  mode: 'CAROUSEL',
  intervalMs: 5000,
  enabled: false,
  items: []
})

export default {
  namespaced: true,
  state: {
    data: emptyHero(),
    loading: false,
    loaded: false,
    locale: '',
    error: ''
  },
  getters: {
    mode(state) {
      return state.data.mode || 'CAROUSEL'
    },
    intervalMs(state) {
      return state.data.intervalMs ?? 5000
    },
    enabled(state) {
      return state.data.enabled !== false
    },
    items(state) {
      return state.data.items || []
    },
    carouselItems(state, getters) {
      return getters.items.filter(
        (item) =>
          (item.itemType || 'IMAGE') === 'IMAGE' &&
          (item.mediaUrl || item.backgroundUrl || item.mobileMediaUrl || item.mobileBackgroundUrl)
      )
    },
    columnItems(state, getters) {
      return getters.items.filter((item) => item.itemType === 'COLUMN')
    },
    videoItem(state, getters) {
      return getters.items.find((item) => item.itemType === 'VIDEO') || null
    },
    hasContent(state, getters) {
      if (!getters.enabled) return false
      if (getters.mode === 'CAROUSEL') {
        return getters.carouselItems.some(
          (item) => item.mediaUrl || item.backgroundUrl || item.mobileMediaUrl || item.mobileBackgroundUrl
        )
      }
      if (getters.mode === 'COLUMNS') {
        return getters.columnItems.length >= 2
      }
      if (getters.mode === 'VIDEO') {
        return Boolean(getters.videoItem?.mediaUrl)
      }
      return false
    }
  },
  mutations: {
    SET_HERO(state, { data, locale }) {
      state.data = data || emptyHero()
      state.loaded = true
      state.locale = locale || ''
      state.error = ''
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error || ''
    },
    RESET(state) {
      state.data = emptyHero()
      state.loaded = false
      state.locale = ''
      state.error = ''
      state.loading = false
    }
  },
  actions: {
    async fetchHero({ commit, state, rootState }, options) {
      const { force = false } = options ?? {}
      const locale = rootState.locale.current
      if (!locale) return

      if (!force && state.loaded && state.locale === locale) return

      if (force) {
        heroFetchSeq += 1
        inflightHeroFetch = null
      }

      if (inflightHeroFetch?.locale === locale && !force) {
        return inflightHeroFetch.promise
      }

      const seq = ++heroFetchSeq
      const task = (async () => {
        commit('SET_LOADING', true)
        commit('SET_ERROR', '')
        try {
          const data = await getPortalHomeHero(locale, { reload: force })
          if (seq !== heroFetchSeq) return
          commit('SET_HERO', { data: normalizeHeroData(data), locale })
        } catch (error) {
          if (seq !== heroFetchSeq) return
          commit('SET_HERO', { data: emptyHero(), locale })
          commit('SET_ERROR', error?.message || '加载失败')
          throw error
        } finally {
          if (seq === heroFetchSeq) {
            commit('SET_LOADING', false)
          }
        }
      })()

      inflightHeroFetch = { locale, promise: task }
      try {
        await task
      } finally {
        if (inflightHeroFetch?.promise === task) {
          inflightHeroFetch = null
        }
      }
    }
  }
}
